// Importer le CSS du polyfill
import 'dialog-polyfill/dist/dialog-polyfill.css';

// Le SCSS d'Usito est géré par l'entry point usito-mots.js (styles-mots.scss)
// Importer le JS du polyfill
import dialogPolyfill from 'dialog-polyfill';

import {GestionnaireOnglets} from "./mots/GestionnaireOnglets.js";
import {GestionnaireAlphabetPhonétique} from "./mots/GestionnaireAlphabetPhonétique.js";
import {GestionnaireSuggestions} from "./mots/GestionnaireSuggestions.js";
import {ConstructeurDeRecherche} from "./mots/ConstructeurDeRecherche.js";
import {UsitoMots} from "./mots/UsitoMots.js";
import {GestionnaireHistorique} from "./mots/GestionnaireHistorique.js";
import Dexie from "./node_modules/dexie/dist/dexie.mjs";
import {TriColonneInfo} from "./mots/composants/TriColonneInfo.js";
import {TableauRecherches} from "./mots/composants/TableauRecherches.js";
import {GestionnaireFavoris} from "./mots/GestionnaireFavoris.js";
import {GestionnaireURL} from "./mots/GestionnaireURL.js";

// Attache le polyfill à tous les éléments <dialog>
function polyfillDialogs() {
    const dialogs = document.querySelectorAll('dialog');
    dialogs.forEach(dialog => {
        dialogPolyfill.registerDialog(dialog);
    });
}

function enregistrementComposants() {
    customElements.define(TriColonneInfo.nom, TriColonneInfo);
    customElements.define(TableauRecherches.nom, TableauRecherches);
}


function getUsitoBD() {
    const usitoBD = new Dexie('usito');

    usitoBD.version(1).stores({
        historique: 'url,ts',
        recherches: 'hash,ts',
        recherchesFavorites: 'hash,ts'
    });

    usitoBD.open().catch(function (err) {
        console.error('Erreur de connexion à la BD: ' + (err.stack || err));
    });
    return usitoBD;
}

/* Détecteurs d'événements */
document.addEventListener('DOMContentLoaded', () => {

    if (document.getElementById("critèresRechercheMots")) {

        polyfillDialogs();

        enregistrementComposants();

        const usitoBD = getUsitoBD();

        let gestionnaireOnglets = new GestionnaireOnglets();
        let gestionnaireAlphabetPhonétique = new GestionnaireAlphabetPhonétique();
        let constructeurRecherche = new ConstructeurDeRecherche(gestionnaireAlphabetPhonétique);
        let gestionnaireSuggestions = new GestionnaireSuggestions(constructeurRecherche);
        let gestionnaireFavoris = new GestionnaireFavoris(constructeurRecherche, usitoBD);
        let gestionnaireHistorique = new GestionnaireHistorique(constructeurRecherche, usitoBD, gestionnaireFavoris);

        let usitoMots = new UsitoMots(
            constructeurRecherche,
            gestionnaireOnglets,
            gestionnaireAlphabetPhonétique,
            gestionnaireSuggestions,
            gestionnaireHistorique,
            gestionnaireFavoris
        );

        usitoMots.démarre();
    }
});














